// src/modules/hr/constants/hrConstants.js
// Mirrors backend constants/hrEnums.js

export const EMPLOYMENT_TYPE_OPTIONS = [
  { label: 'Permanent', value: 'PERMANENT' },
  { label: 'Contract', value: 'CONTRACT' },
  { label: 'Consultant', value: 'CONSULTANT' },
  { label: 'Intern', value: 'INTERN' },
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE', color: 'green' },
  { label: 'Inactive', value: 'INACTIVE', color: 'default' },
  { label: 'Resigned', value: 'RESIGNED', color: 'orange' },
  { label: 'Terminated', value: 'TERMINATED', color: 'red' },
];

export const MARITAL_STATUS_OPTIONS = [
  { label: 'Single', value: 'SINGLE' },
  { label: 'Married', value: 'MARRIED' },
  { label: 'Divorced', value: 'DIVORCED' },
  { label: 'Widowed', value: 'WIDOWED' },
];

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Other', value: 'OTHER' },
];

export const ASSET_CATEGORY_OPTIONS = [
  'LAPTOP', 'DESKTOP', 'MONITOR', 'PRINTER', 'SCANNER', 'MOBILE', 'SIM_CARD', 'VEHICLE',
  'BIOMETRIC_DEVICE', 'GOLD_TESTING_MACHINE', 'DENSITY_METER', 'WEIGHING_SCALE',
  'THERMAL_PRINTER', 'UPS', 'FURNITURE', 'NETWORK_EQUIPMENT', 'OTHER',
].map((v) => ({ label: v.replace(/_/g, ' '), value: v }));

export const ASSET_STATUS_OPTIONS = [
  { label: 'Available', value: 'AVAILABLE', color: 'green' },
  { label: 'Assigned', value: 'ASSIGNED', color: 'blue' },
  { label: 'Repair', value: 'REPAIR', color: 'orange' },
  { label: 'Damaged', value: 'DAMAGED', color: 'red' },
  { label: 'Lost', value: 'LOST', color: 'volcano' },
  { label: 'Disposed', value: 'DISPOSED', color: 'default' },
];

export const ASSET_CONDITION_OPTIONS = ['NEW', 'GOOD', 'FAIR', 'POOR', 'DAMAGED']
  .map((v) => ({ label: v.charAt(0) + v.slice(1).toLowerCase(), value: v }));

export const HOLIDAY_TYPE_OPTIONS = [
  { label: 'National', value: 'NATIONAL', color: 'red' },
  { label: 'State', value: 'STATE', color: 'blue' },
  { label: 'Branch', value: 'BRANCH', color: 'cyan' },
  { label: 'Emergency', value: 'EMERGENCY', color: 'volcano' },
];

export const ATTENDANCE_STATUS_OPTIONS = [
  { label: 'Present', value: 'PRESENT', color: 'green' },
  { label: 'Absent', value: 'ABSENT', color: 'red' },
  { label: 'Half Day', value: 'HALF_DAY', color: 'orange' },
  { label: 'Late', value: 'LATE', color: 'volcano' },
  { label: 'Leave', value: 'LEAVE', color: 'blue' },
  { label: 'Holiday', value: 'HOLIDAY', color: 'purple' },
  { label: 'Weekly Off', value: 'WEEKLY_OFF', color: 'default' },
];

export const LATE_ARRIVAL_STATUS_OPTIONS = [
  { label: 'Pending', value: 'PENDING', color: 'processing' },
  { label: 'Approved', value: 'APPROVED', color: 'success' },
  { label: 'Rejected', value: 'REJECTED', color: 'error' },
];

export const LEAVE_TYPE_OPTIONS = [
  { label: 'Casual', value: 'CASUAL' },
  { label: 'Sick', value: 'SICK' },
  { label: 'Earned', value: 'EARNED' },
  { label: 'Maternity', value: 'MATERNITY' },
  { label: 'Paternity', value: 'PATERNITY' },
  { label: 'Bereavement', value: 'BEREAVEMENT' },
  { label: 'Leave Without Pay', value: 'LWP' },
];

export const LEAVE_STATUS_OPTIONS = [
  { label: 'Pending Manager', value: 'PENDING_MANAGER', color: 'gold' },
  { label: 'Pending HR', value: 'PENDING_HR', color: 'orange' },
  { label: 'Approved', value: 'APPROVED', color: 'green' },
  { label: 'Rejected', value: 'REJECTED', color: 'red' },
  { label: 'Cancelled', value: 'CANCELLED', color: 'default' },
];

export const DOCUMENT_TYPE_OPTIONS = [
  'PHOTO', 'AADHAAR', 'PAN', 'OFFER_LETTER', 'APPOINTMENT_LETTER', 'NDA',
  'EDUCATIONAL_CERTIFICATE', 'EXPERIENCE_CERTIFICATE', 'INCREMENT_LETTER',
  'WARNING_LETTER', 'EXIT_DOCUMENT', 'PAYSLIP', 'OTHER',
].map((v) => ({ label: v.replace(/_/g, ' '), value: v }));

export const EXIT_TYPE_OPTIONS = [
  { label: 'Resignation', value: 'RESIGNATION' },
  { label: 'Termination', value: 'TERMINATION' },
  { label: 'Retirement', value: 'RETIREMENT' },
  { label: 'Absconding', value: 'ABSCONDING' },
];

export const EXIT_STATUS_OPTIONS = [
  { label: 'Initiated', value: 'INITIATED', color: 'gold' },
  { label: 'Notice Period', value: 'NOTICE_PERIOD', color: 'blue' },
  { label: 'Clearance Pending', value: 'CLEARANCE_PENDING', color: 'orange' },
  { label: 'Cleared', value: 'CLEARED', color: 'cyan' },
  { label: 'Completed', value: 'COMPLETED', color: 'green' },
  { label: 'Cancelled', value: 'CANCELLED', color: 'default' },
];

export const CLEARANCE_STATUS_OPTIONS = [
  { label: 'Pending', value: 'PENDING', color: 'orange' },
  { label: 'Done', value: 'DONE', color: 'green' },
  { label: 'N/A', value: 'NA', color: 'default' },
];

export const tagColor = (options, value) => options.find((o) => o.value === value)?.color || 'default';
export const tagLabel = (options, value) => options.find((o) => o.value === value)?.label || value;
